import React, { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import ProjectShowcase from './components/ProjectShowcase';
import CapabilitiesPreview from './components/CapabilitiesPreview';
import ClientLogos from './components/ClientLogos';
import DevelopmentInsights from './components/DevelopmentInsights';
import InnovationLabTeaser from './components/InnovationLabTeaser';
import MobileExperience from './components/MobileExperience';
import Icon from '../../components/AppIcon';
import Image from '../../components/AppImage';


const Homepage = () => {
  useEffect(() => {
    // Set page title
    document.title = 'Manica Solutions - Digital Transformation Architects';
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Transform your business with expert software development. Manica Solutions architects digital solutions that drive growth, enhance efficiency, and create competitive advantages.');
    }

    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';

    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <>
      {/* Hero Section with Dynamic Code Visualization */}
      <HeroSection />
      
      {/* Interactive Project Showcase */}
      {/* <ProjectShowcase /> */}
      
      {/* Capabilities Preview with Live Code Examples */}
      <CapabilitiesPreview />
      
      {/* Client Logo Constellation */}
      {/* <ClientLogos /> */}
      
      {/* Real-Time Development Insights */}
      {/* <DevelopmentInsights /> */}
      
      {/* Innovation Lab Teaser */}
      {/* <InnovationLabTeaser /> */}
      
      {/* Mobile-Optimized Experience */}
      <MobileExperience />
    </>
  );
};

export default Homepage;